import type { Prompt } from '@/features/orchestration/types'
import { API_BASE, createHeaders } from './base'

export async function getPrompts(type?: string): Promise<Prompt[]> {
  const params = new URLSearchParams()
  if (type) params.set('type', type)
  const url = `${API_BASE}/prompts${params.toString() ? '?' + params.toString() : ''}`
  const response = await fetch(url, { headers: createHeaders() })
  if (!response.ok) throw new Error('Failed to fetch prompts')
  return response.json()
}

export async function createPrompt(data: {
  name: string
  description?: string
  content: string
  tags?: string[]
  type: string
}): Promise<Prompt> {
  const response = await fetch(`${API_BASE}/prompts`, {
    method: 'POST',
    headers: createHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify(data),
  })
  if (!response.ok) throw new Error('Failed to create prompt')
  return response.json()
}

export async function updatePromptApi(id: number, data: Record<string, unknown>): Promise<Prompt> {
  const response = await fetch(`${API_BASE}/prompts/${id}`, {
    method: 'PUT',
    headers: createHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify(data),
  })
  if (!response.ok) throw new Error('Failed to update prompt')
  return response.json()
}

export async function deletePromptApi(id: number): Promise<void> {
  const response = await fetch(`${API_BASE}/prompts/${id}`, {
    method: 'DELETE',
    headers: createHeaders(),
  })
  if (!response.ok) throw new Error('Failed to delete prompt')
}

export async function readExternalPromptContent(path: string): Promise<string> {
  const response = await fetch(
    `${API_BASE}/prompts/external/content?path=${encodeURIComponent(path)}`,
    { headers: createHeaders() }
  )
  if (!response.ok) throw new Error('Failed to read external prompt')
  const data = await response.json()
  return data.content
}
